import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"
import { makeBusyFunction } from "lib/@components/busy/make-busy-function"

export const applyScheduleResolutions = api(
    makeBusyFunction(async function applyScheduleResolutions({ id }) {
        return mutate(
            gql`
                mutation ApplyScheduleResolutions($id: ID!) {
                    applyScheduleResolutions(id: $id)
                }
            `,
            { id },
            { returns: "applyScheduleResolutions" }
        )
    }, "Applying accepted changes to schedule…")
)
